module.exports = __webpack_public_path__ + "static/media/header-img.d10711da.jpg";